/**
 * Lab ScoreDashboard / ResultScoreBoard rate chips: always show lay/back
 * (e.g. 100/100), not category char letters.
 */

export type ScoreRateOpt = {
  rateLay?: number
  rateBack?: number
  rateNo?: string | null
  char?: string | null
}

/** Chip label — prefer lay/back like Lab ResultScoreBoard. */
export function formatScoreRateChip(rate: ScoreRateOpt): string {
  if (rate.rateLay != null && rate.rateBack != null) {
    return `${rate.rateLay}/${rate.rateBack}`
  }
  return String(rate.rateNo ?? rate.char ?? '').trim()
}

/** Map API rates so rateNo is the chip label used for display + active match. */
export function mapRatesForScoreboard<T extends ScoreRateOpt>(rateList: T[]): Array<T & { rateNo: string }> {
  return (rateList ?? []).map((item) => ({
    ...item,
    rateNo: formatScoreRateChip(item) || String(item.rateNo ?? item.char ?? ''),
  }))
}

export function isScoreRateActive(ratesNo: string, rate: ScoreRateOpt): boolean {
  const chip = formatScoreRateChip(rate)
  if (!chip) return false
  if (ratesNo === chip) return true
  const labeled = String(rate.rateNo ?? rate.char ?? '').trim()
  return labeled !== '' && ratesNo === labeled
}

/** Active run chip: explicit runButtonValue, else Yes−No gap (Lab Results). */
export function isScoreRunActive(opts: {
  runNo: number
  runButtonValue?: number | string | null
  runner1?: number | string
  runner2?: number | string
}): boolean {
  if (
    opts.runButtonValue != null &&
    opts.runButtonValue !== '' &&
    Number.isFinite(Number(opts.runButtonValue))
  ) {
    return Number(opts.runButtonValue) === Number(opts.runNo)
  }
  const r1 = Number(opts.runner1)
  const r2 = Number(opts.runner2)
  if (Number.isFinite(r1) && Number.isFinite(r2)) {
    return r2 - r1 === Number(opts.runNo)
  }
  return false
}
